// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShareGifPage_wrapper_1guwt","video":"ShareGifPage_video_ctTMx","logo":"ShareGifPage_logo_3uhcu"};